module.exports = __webpack_public_path__ + "media/images/countrysquared/lc-170da198ba2ce39d1de4d8f39f104d71.svg";